import React, { Component } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
import { Redirect, Route, RouteComponentProps, RouteProps, Switch, useRouteMatch } from 'react-router';
import ConnectorDealsHome from './connector/deals';
import ConnectorNetworkHome from './connector/network';
import ConnectorProfileHome from './connector/profile';
import { ConnectorContextProvider, useUser } from '../contexts';
import { Role } from '../types/types';
import ConnectorHome from './connector/home';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    minWidth: theme.breakpoints.values.md,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    backgroundColor: theme.palette.background.default,

    '& .MuiAvatar-img': {
      backgroundColor: '#FFF'
    }
  }
}));

const ConnectorPage = () => {
  const { path } = useRouteMatch();
  const classes = useStyles();

  return (
    <ConnectorContextProvider>
      <Container maxWidth='xl' className={classes.root}>
        <Switch>
          <RoleRestrictedRoute path={`${path}/deals`} component={ConnectorDealsHome} allowedRoles={[Role.Connector]} />
          <RoleRestrictedRoute path={`${path}/network`} component={ConnectorNetworkHome} allowedRoles={[Role.Connector]} />
          <RoleRestrictedRoute path={`${path}/activity`} component={ConnectorHome} allowedRoles={[Role.Connector]} />
          <Route path={`${path}/:profileId`} component={ConnectorProfileHome} />
        </Switch>
      </Container>
    </ConnectorContextProvider>
  );
};

interface PrivateRouteProps extends RouteProps {
  component: any;
  allowedRoles: Role[];
}

const RoleRestrictedRoute = (props: PrivateRouteProps) => {
  const { userInfo } = useUser();
  const { allowedRoles, ...rest } = props;

  console.log('props', props);

  if (allowedRoles.find((role) => role === userInfo?.role)) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Route {...rest} />;
  }

  return <Redirect to='/' />;
};

export default ConnectorPage;
